/* Component-specific styles only */
.chart-placeholder {
  height: 300px;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
}
.link-stats-table {
  width: 100%;
  border-collapse: collapse;
}
.link-stats-table th,
.link-stats-table td {
  padding: var(--padding);
  text-align: left;
  border-bottom: var(--border);
  font-size: var(--font-size);
}
.link-stats-table th {
  background: color-mix(in oklab, var(--color-bg-secondary), black 10%);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
}
.link-stats-table tr {
  border-bottom: 2px solid color-mix(in oklab, var(--color-bg-primary), white 10%);
}
.link-stats-table tr:hover {
  background-color: color-mix(in oklab, var(--color-bg-secondary), white 10%);
}
.bar {
  background: var(--color-bg-accent);
  height: 1.5rem;
  border-radius: var(--border-radius);
  min-width: 2rem;
}
.bar-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.referrer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.referrer-item {
  padding: var(--padding);
  border-bottom: var(--border);
  background: var(--color-bg-primary);
  border-radius: var(--border-radius);
  margin-bottom: var(--margin);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
.referrer-item:hover {
  background: color-mix(in oklab, var(--color-bg-secondary), black 10%);
}
.referrer-item:last-child {
  border-bottom: none;
}
.referrer-url {
  color: var(--color-text-accent);
  text-decoration: none;
  font-size: var(--font-size);
}
.referrer-url:hover {
  text-decoration: underline;
}
.referrer-count {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: var(--font-size);
}
.simple-chart {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  height: 200px;
  padding: 1rem 0;
}
.chart-bar {
  flex: 1;
  background: var(--color-bg-accent);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  min-height: 4px;
  position: relative;
  transition: opacity 0.2s;
}
.chart-bar:hover {
  opacity: 0.8;
}
.chart-bar-label {
  position: absolute;
  bottom: -1.5rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  white-space: nowrap;
}
.chart-wrapper {
  padding-bottom: 2rem;
}
.date-range {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--padding-l);
  justify-content: flex-start;
  margin: var(--padding-xxl) 0;
}
.date-range label {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: var(--padding);
  font-size: var(--font-size);
  font-weight: var(--font-weight-bold);
}
.date-range select {
  width: 100%;
  padding: var(--padding-l);
  font-size: var(--font-size);
}
@media (max-width: 768px) {
  .analytics-container {
    padding: var(--padding-l);
  }
  .header h2 {
    font-size: var(--font-size-xl);
  }
  .date-range {
    flex-direction: column;
    align-items: stretch;
    gap: var(--padding-l);
  }
  .date-range label {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--padding);
    font-size: var(--font-size);
    font-weight: var(--font-weight-bold);
  }
  .date-range select {
    width: 100%;
    padding: var(--padding-l);
    font-size: var(--font-size);
  }
  .stats-grid {
    grid-template-columns: 1fr;
    gap: var(--padding-l);
    margin-bottom: var(--padding-xl);
  }
  .stat-card {
    padding: var(--padding-l);
  }
  .stat-value {
    font-size: var(--font-size-xl);
  }
  .charts-section {
    margin-bottom: var(--padding-xl);
  }
  .chart-card {
    padding: var(--padding-xl);
    margin-bottom: var(--padding-xl);
  }
  .chart-title {
    font-size: var(--font-size-l);
  }
  .chart-placeholder {
    height: 200px;
  }
  .link-stats-table {
    display: block;
    overflow-x: auto;
  }
  .link-stats-table th,
  .link-stats-table td {
    padding: var(--padding-l);
    font-size: var(--font-size);
  }
  .bar-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .referrer-item {
    padding: var(--padding);
    flex-direction: column;
    align-items: flex-start;
    gap: var(--padding);
  }
}
